export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-5 whitespace-nowrap">
            <i className="ri-information-line"></i>
            关于平台
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
            关于51吃瓜网
          </h2>
          <p className="text-foreground-600 text-sm leading-relaxed mb-4">
            51吃瓜网官网是国内领先的娱乐资讯聚合平台，自上线以来始终坚持
            <strong className="text-foreground-800 font-medium">"快速、全面、真实"</strong>
            的内容理念，为千万用户提供一站式吃瓜体验。
          </p>
          <p className="text-foreground-600 text-sm leading-relaxed mb-4">
            平台通过智能采集与人工审核相结合的方式，覆盖娱乐八卦、影视综艺、音乐现场、
            网红动态、明星资讯等多个垂直领域，日均更新超过200条优质内容。
            我们提供手机版、网页版和独立APP三种访问方式，
            所有版本共享同一永久域名，确保用户随时随地畅快访问。
          </p>
          <p className="text-foreground-600 text-sm leading-relaxed">
            作为聚合平台，51吃瓜网不生产谣言，只做优质信息的搬运工和整理者。
            我们致力于为用户打造一个安全、便捷、内容丰富的娱乐资讯入口，
            让每一个爱吃瓜的人都能在这里找到最新、最全、最有趣的娱乐内容。
          </p>
        </div>
      </div>
    </section>
  );
}